export default __webpack_public_path__ + "static/media/15.7b35fdd1.jpg";